import { render, staticRenderFns } from "./Thirdstep.vue?vue&type=template&id=64122a52&scoped=true&"
import script from "./Thirdstep.vue?vue&type=script&lang=js&"
export * from "./Thirdstep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64122a52",
  null
  
)

export default component.exports